export default __webpack_public_path__ + "static/media/star.833feb8d.svg";